<template>
  <form class="w-full max-w-sm">
    <div class="flex items-center border-b border-b-2 border-orange-500 py-2">
      <input v-model="username" class="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none" autocomplete="email" type="text" placeholder="Email" aria-label="Email">
      <input v-model="password" class="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none" autocomplete="current-password" type="password" placeholder="Password" aria-label="Password">
      <button @click="onLogin" class="flex-shrink-0 bg-orange-500 hover:bg-orange-700 border-orange-500 hover:border-orange-700 text-sm border-4 text-white py-1 px-2 rounded focus:outline-none" type="button">
        Login
      </button>
    </div>

    <div v-if="errorMsg" class=" text-red-500">{{ errorMsg }}</div>
  </form>
</template>

<script>
import * as API from '../api/api'

export default {
  data () {
    return {
      username: '',
      password: '',
      errorMsg: false
    }
  },
  methods: {
    async onLogin () {
      let { username, password } = this
      try {
        this.errorMsg = false
        let info = await API.login({ username, password })
        // console.log(info)
        API.rememberMe({ profile: { user: info.user, jwt: info.jwt } })
        // console.log(API.getLoggedInList())
        this.$router.push('/app/home')
      } catch (e) {
        if (e && e.response && e.response.data && e.response.data.error) {
          console.log(e.response.data.error)
          this.errorMsg = e.response.data.error
        }
      }
    }
  }
}
</script>

<style lang="postcss">

</style>
